import React from 'react'
import PropTypes from 'prop-types'
import withDeviceHeightResize from 'LiveBoard/components/shared/hocs/withDeviceHeightResize'

const ItemViewerWrapper = (props) => {

  const bannerHeightClass = `${props.bannerHeight}-banner`

  return (
    <section
      className={`item-viewer
                  ${props.bannerHeight ? bannerHeightClass : ""}
                  ${!!props.isVideoItem ? "video-item" : ""}`} >
      {props.children}
    </section>
  )
}

ItemViewerWrapper.propTypes = {
  bannerHeight: PropTypes.string.isRequired,
  deviceHeight: PropTypes.number,
  isVideoItem: PropTypes.bool
}

export default withDeviceHeightResize(ItemViewerWrapper)
